/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/assets/js/custom-product-list.js ***!
  \**********************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// toggle on the top of the product list
var CustomProductListToggle = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomProductListToggle, _HTMLElement);
  var _super = _createSuper(CustomProductListToggle);
  function CustomProductListToggle() {
    var _this;
    _classCallCheck(this, CustomProductListToggle);
    _this = _super.call(this);
    _this.toggleButtons = _this.querySelectorAll('.custom-product-list__toggle-item');
    return _this;
  }
  _createClass(CustomProductListToggle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.toggleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this2.toggleActiveClass(button);
        });
      });
    }
  }, {
    key: "toggleActiveClass",
    value: function toggleActiveClass(button) {
      this.toggleButtons.forEach(function (button) {
        button.classList.remove('active');
      });
      button.classList.add('active');
      document.querySelectorAll('custom-product-card').forEach(function (card) {
        card.toggleSubscription();
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this3 = this;
      this.setEventListeners();
      setTimeout(function () {
        _this3.querySelector('[data-rent="rent"]').click();
      }, 200);
    }
  }]);
  return CustomProductListToggle;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-list-toggle')) {
  customElements.define('custom-product-list-toggle', CustomProductListToggle);
}

// product card, mostly used to store data and trigger modal open
var CustomProductCard = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(CustomProductCard, _HTMLElement2);
  var _super2 = _createSuper(CustomProductCard);
  function CustomProductCard() {
    var _this4;
    _classCallCheck(this, CustomProductCard);
    _this4 = _super2.call(this);
    _this4.triggerButtons = _this4.querySelectorAll('.custom-product-card--trigger');
    _this4.targetPopupId = _this4.dataset.targetpopup;
    _this4.targetPopup = document.querySelector("[data-popupid=\"".concat(_this4.targetPopupId, "\"]"));
    _this4.product = _this4.dataset.product;
    _this4.originalPrice = _this4.dataset.price;
    _this4.mode = 'Buy';
    _this4.parentSection = _this4.closest('.shopify-section');
    _this4.priceElm = _this4.querySelector('.custom-product-card__meta-price span');
    return _this4;
  }
  _createClass(CustomProductCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "toggleSubscription",
    value: function toggleSubscription() {
      if (this.mode == 'Buy') {
        this.mode = 'Rent';
        this.parentSection.classList.add('rent-mode');
      } else {
        this.mode = 'Buy';
        this.parentSection.classList.remove('rent-mode');
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this5 = this;
      this.triggerButtons.forEach(function (button) {
        button.onclick = function () {
          _this5.targetPopup.openModal(_this5.product);
        };
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-card')) {
  customElements.define('custom-product-card', CustomProductCard);
}
var CustomProductTabs = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(CustomProductTabs, _HTMLElement3);
  var _super3 = _createSuper(CustomProductTabs);
  function CustomProductTabs() {
    var _this6;
    _classCallCheck(this, CustomProductTabs);
    _this6 = _super3.call(this);
    _this6.tabButtons = _this6.querySelectorAll('.custom-product-tabs__tab-button');
    _this6.tabs = _this6.querySelectorAll('.custom-product-tabs__tab-content');
    _this6.activeButtonClass = 'custom-product-tabs__tab-button--active';
    _this6.activeTabClass = 'custom-product-tabs__tab-content--active';
    return _this6;
  }
  _createClass(CustomProductTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this7 = this;
      this.tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          _this7.toggleActiveTab(index);
        });
      });
    }
  }, {
    key: "toggleActiveTab",
    value: function toggleActiveTab(index) {
      var _this8 = this;
      this.tabButtons.forEach(function (button) {
        button.classList.remove(_this8.activeButtonClass);
      });
      this.tabs.forEach(function (tab) {
        tab.classList.remove(_this8.activeTabClass);
      });
      this.tabButtons[index].classList.add(this.activeButtonClass);
      this.tabs[index].classList.add(this.activeTabClass);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-tabs__desktop')) {
  customElements.define('custom-product-tabs__desktop', CustomProductTabs);
}

// to do: atc-component

// modal popup
var CustomProductPopup = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(CustomProductPopup, _HTMLElement4);
  var _super4 = _createSuper(CustomProductPopup);
  function CustomProductPopup() {
    var _this9;
    _classCallCheck(this, CustomProductPopup);
    _this9 = _super4.call(this);
    _this9.overlay = _this9.querySelector('.custom-product-popup__overlay');
    _this9.closeButton = _this9.querySelector('.custom-product-popup__icon-close');
    _this9.contentWrapper = _this9.querySelector('.custom-product-popup-wrapper__content');
    _this9.body = document.body;
    return _this9;
  }
  _createClass(CustomProductPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this10 = this;
      this.closeButton.addEventListener('click', function () {
        _this10.closeModal();
      });
      this.overlay.addEventListener('click', function () {
        _this10.closeModal();
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.style.display = 'none';
      this.overlay.style.display = 'none';
      this.body.style.overflow = 'auto';
    }
  }, {
    key: "openModal",
    value: function openModal(product) {
      this.style.display = 'flex';
      this.overlay.style.display = 'block';
      this.body.style.overflow = 'hidden';
      if (product) {
        this.pullProduct(product);
      }
    }
  }, {
    key: "pullProduct",
    value: function pullProduct(productUrl) {
      var _this11 = this;
      // Add loading class to the whole popup
      this.classList.add('loading');

      // Perform the fetch request
      fetch("".concat(productUrl, "?view=ajax")).then(function (response) {
        return response.text();
      }).then(function (htmlString) {
        // Create a temporary container to hold the response HTML
        var tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlString;

        // Extract content from .custom-product-popup-wrapper__content
        var content = tempContainer.querySelector('.custom-product-popup-wrapper__content');
        if (content) {
          // Update the contentWrapper innerHTML
          _this11.contentWrapper.innerHTML = content.innerHTML;
          if (_this11.querySelector('.swiper')) {
            _this11.startSwiper();
          }
        }

        // Remove loading class after content is loaded
        _this11.classList.remove('loading');
      })["catch"](function (error) {
        console.error('Error fetching product:', error);
        // Remove loading class in case of an error
        _this11.classList.remove('loading');
      });
    }
  }, {
    key: "startSwiper",
    value: function startSwiper() {
      var _this12 = this;
      this.slider = this.querySelector('.swiper');
      this.nextArrow = this.querySelector('.swiper-button-next');
      this.prevArrow = this.querySelector('.swiper-button-prev');
      var main_options = {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: this.nextArrow,
          prevEl: this.prevArrow
        }
      };
      var initSwiper = function initSwiper() {
        if (typeof Swiper === 'undefined') {
          return false;
        }
        _this12.activeSlider = new Swiper(_this12.slider, main_options);
        return true;
      };
      var swiperCheckInterval = setInterval(function () {
        if (initSwiper()) {
          clearInterval(swiperCheckInterval);
        }
      }, 100);
    }
  }, {
    key: "toggleActiveClass",
    value: function toggleActiveClass(button) {
      this.toggleButtons.forEach(function (button) {
        button.classList.remove('active');
      });
      button.classList.add('active');
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-popup')) {
  customElements.define('custom-product-popup', CustomProductPopup);
}

// atc wrapper
var AtcComponent = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(AtcComponent, _HTMLElement5);
  var _super5 = _createSuper(AtcComponent);
  function AtcComponent() {
    var _this13;
    _classCallCheck(this, AtcComponent);
    _this13 = _super5.call(this);
    _this13.variant = _this13.dataset.variant;
    _this13.plans = JSON.parse(_this13.dataset.plans);
    _this13.parentSection = _this13.closest('.shopify-section');
    _this13.button = _this13.querySelector('button');
    _this13.initialText = _this13.textContent;
    _this13.loadingText = _this13.dataset.loading;
    _this13.successText = _this13.dataset.success;
    return _this13;
  }
  _createClass(AtcComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this14 = this;
      this.button.addEventListener('click', function () {
        _this14.addToCart();
      });
    }
  }, {
    key: "addToCart",
    value: function addToCart() {
      
      var _this15 = this;
      var toggle_info = this.closest('.custom-product-card__meta').querySelector('.custom-product-list__toggle-item.active').dataset.rent;
      
      // Add loading class to the whole popup
      this.classList.add('loading');
      this.button.textContent = this.loadingText;
      var data = {
        "id": this.variant,
        "quantity": 1
      };
      if (toggle_info == 'rent') {
        var selling_plan_id = this.plans[0].selling_plans[0].id;        
        var frequency = this.plans[0].selling_plans[0].options[0].value;
        data['selling_plan'] = selling_plan_id;
        data['properties'] = {
          "_shipping_interval_frequency": frequency,
          "_shipping_interval_unit_type": 'Month'
        };
      }

      // Perform the fetch request
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        // this.updateCart(data);
        _this15.button.textContent = _this15.successText;
        _this15.classList.remove('loading');
        setTimeout(function () {
          _this15.button.textContent = _this15.initialText;
          fetch(window.location.href).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            document.querySelector('.cart-count-bubble').innerHTML = doc.querySelector('.cart-count-bubble').innerHTML;
          })["catch"](function (err) {
            console.warn('Something went wrong.', err);
          });
        }, 1000);
      })["catch"](function (error) {
        console.error('Error fetching product:', error);
        // Remove loading class in case of an error
        _this15.classList.remove('loading');
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return AtcComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('atc-component')) {
  customElements.define('atc-component', AtcComponent);
}
/******/ })()
;